const Logos = () => {
  const companies = ["Data Center Solutions", "Image Staffing", "Black Diamond Financial", "Ad-Walls", "Tempus Hair Restoration", "Veritech"];
  return (
    <section className="border-y border-border bg-card/50 py-12">
      <div className="container">
        <p className="text-center text-sm font-medium uppercase tracking-widest text-muted-foreground">
          Trusted by 25,000+ growing teams
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
          {companies.map((c) => (
            <span key={c} className="font-display text-2xl font-bold text-muted-foreground/70 transition-colors hover:text-secondary">
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;
